export const INITIAL_FORM_DATA = {
  userApiToken: "",
  userBearerToken: "",
  userEmail: "",
  userType: "",
  companyId: "",
  companyName: "",
};
